// extracted by mini-css-extract-plugin
export var black = "_2y-6";
export var brand = "_2y-1";
export var ddefault = "_2y-0";
export var error = "_2y-3";
export var gray = "_2y-2";
export var highContrast = "_2y-8";
export var outline = "_2y-7";
export var success = "_2y-5";
export var warning = "_2y-4";